import {Drawer, Stack, Typography} from '@mui/material'
import AppModal from "@/components/AppModal";
import {useTranslation} from "react-i18next";
import ShippingAddressForm from "./ShippingAddressForm";
import RpIcon from "@/components/RpIcon.jsx";
import RouteConstant from "@/constant/RouteConstant.js";
import React from "react";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader";
import {enqueueSnackbar} from "notistack";

export default function ShippingAddressDialog({open, onClose}) {
  const {t} = useTranslation();
  const onSuccess = () => {
    enqueueSnackbar(t("success"), {variant: 'success'})
    onClose && onClose();
  }
  return (<>
    <Drawer anchor="right" open={open} onClose={onClose} title={t('shipping_address')}>
      <Stack>
        {/*<SimpleHeader title={t('shipping_address')}/>*/}
        {/*<Stack sx={{padding: '6px 16px'}} direction="row" alignItems="center" spacing={2}>*/}
        {/*  <RpIcon icon="arrow-left" clickable*/}
        {/*  onClick={() => {*/}
        {/*    onClose();*/}
        {/*  }}*/}
        {/*  />*/}
        {/*  <Typography>{t('shipping_address')}</Typography>*/}
        {/*</Stack>*/}

        <SimpleHeader
            title={t('shipping_address')}
            closeButton={<RpIcon icon="arrow-left" clickable onClick={() => {onClose()}}/>}
        />
        <Stack sx={{padding: '16px'}}>
          <ShippingAddressForm onSuccess={onSuccess}/>

        </Stack>

      </Stack>

    </Drawer>
  </>);
}
